<template>
  <div id="app">
    <div id="J_prismPlayer"></div>

    <!-- <div style="padding-top: 30px; width: 100%; height: 360px; position: relative;">
      <video
        id="video"
        preload="auto"
        muted
        class="video-js vjs-default-skin"
        style="width: 100%; height: 100%; object-fit: fill"
      >
      <source src="https://shipindianbo.chinaaudiovisual.cn/vod-d44f9a/b0519a5a615671f0877e1777b3cf0102/aaf60b2d5fd841da940601cabf91e946-a1f7be3ff3848635e14b5aecb6be5fcb-hd.m3u8?sign=6cp3Lo87ioxvxE28M9oHxB2S49WLJvwNQry9QKTlDOWf4qtta96SMBIjKZOPJPRt0kCoiNmnY7Yi3frC5OkHovcAiYu%2BrM7Cv7W%2BebsBT%2BpiyAl9x9QO%2B%2BDyU6H5olydJ6ERM3jduXMwAMXwqybr6Q%3D%3D&_t=1756780953615" type="application/x-mpegURL" />
      </video>
    </div> -->

  <input type="text" v-model="urlText" >

  <button @click="playVideo">点我阿里播放</button>
  <!-- <button @click="getVideo">点我videoJS播放</button> -->

  </div>
</template>

<script>

import videojs from 'video.js'
import 'videojs-contrib-hls'

export default {
  name: 'App',
  data(){
    return {
      urlText: ""
    }
  },
  methods:{
    playVideo(val){
      var player = new Aliplayer({
        id: 'J_prismPlayer',
        source: this.urlText
      });
    },


    getVideo () {
      videojs('video', {
        bigPlayButton: true,
        textTrackDisplay: false,
        posterImage: false,
        errorDisplay: false,
        controls: true,
        hls: {
          withCredentials: true
        }
      }, function () {
        this.play()
      })
    }

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#J_prismPlayer{
  width: 100% !important;
  height: 600px !important;
}
</style>
